module.exports = {
  company: "BRICS (Xiamen) International Fisheries Trading Co., Ltd.",
  copyright: "©2023 ICP Filing：京ICP备16005856号-11",
  lang1: "Home",
  lang2: "Trading Center",
  lang3: "Post Supply",
  lang4: "Data Center",
  lang5: "Featured Aquatic Products",
  lang6: "Platform Rules",
  lang7: "About the Project",
  lang8: "Personal Center",
  lang9: "Login/Register",
  lang10: "Please Select",
  lang11: "Post",
  lang12: "I Want to Sell",
  lang13: "I Want to Buy",
  lang14: "Customer Service",
  lang15: "Workdays: 8:30-17:30 Available",
  lang16: "Phone Consultation",
  lang17: "Post your supply~",
  lang18: "Post your order~",
  lang19: "Click the button to quickly post a transaction or",
  lang20: "Share us your needs",
  lang21: "The platform will respond quickly~",
  lang22: "Let's Chat",
  lang23: "Please Open an Account First",
  lang24:
    "Room 303-5, No. 52 Chengyi North Street, Software Park Phase III, Torch Hi-Tech Zone, Xiamen",
  lang25: "Scan QR Code via WeChat",
  lang26: "Current membership expires on **",
  lang27:
    "You have not purchased the Squid Special Zone Data Service yet. Click to Purchase.",
  lang28: "Operation successful",
  lang29: "Please enter password",
  lang30: "Please enter a 6-digit password",
  lang40: "View More",
  lang41: "Real-Time Exchange Rates",
  lang42: "More",
  lang43: "Currency",
  lang44: "Exchange Rate",
  lang45: "Diesel Price",
  lang46: "Port",
  lang47: "Date",
  lang48: "(Drewry) World Container Index",
  lang49: "Shipping Route",
  lang50: "Week-on-Week Change",
  lang51: "Year-on-Year Change",
  lang52: "Data Driven",
  lang53: "Future Seized",
  lang54: "Real-time Data Hub",
  lang55: "Dynamic Quotation System with Full Market Coverage",
  lang56: "Hourly-updated Market Prices",
  lang57: "Regional Precision Analytics Engine",
  lang58: "Providing Pivotal Regions Including Shidao, Zhoushan, Fujian",
  lang59: "Market Trend Charts",
  lang60: "Trend Forecasting Model",
  lang61: "Integrated Historical Data Charts",
  lang62: "Commodity Price Swing Forecasting System",
  lang63: "Decision Support Toolkit",
  lang64: "Supporting Visualized Data Dashboard",
  lang65: "What Value Does the Data Center Deliver?",
  lang66: "Investment Decision Support",
  lang67:
    "Precisely identifying Price Inflection Points, optimizing asset allocation strategies",
  lang68: "Vertical-Specific Enterprise Strategy",
  lang69:
    "Analyzing In-depth Regional Market Features, Planning Scientific Business Layout",
  lang70: "Holistic Risk Management",
  lang71:
    "Establishing Price alert mechanisms, mitigating market volatility impacts",
  lang72: "Activate Data Subscription",
  lang73: "To Be First-mover",
  lang74: "SUBSCRIBE NOW",
  lang75: "Early Repayment",
  lang76: "Settlement Amount (CNY)",
  lang77: "Full Repayment",
  lang78: "Apply for Early Repayment of Principal (CNY)",
  lang79: "Remaining Unpaid Principal (CNY)",
  lang80: "Repayment Account",
  lang81: "Repayment Account Number",
  lang82: "Apply for a Debit",
  lang83: "Please Enter Repayment Amount",
  lang84: "Repayment Record",
  lang85: "Remaining Principal (CNY)",
  lang86: "Principal (CNY)",
  lang87: "Interest (CNY)",
  lang88: "Repayment Time",
  lang89: "Repayment Amount (CNY)",
  lang90: "Short Transaction Description",
  lang91: "Penalty on Interest (CNY)",
  lang92: "Penalty on Principal (CNY)",
  lang93: "Fee (CNY)",
  lang94: "Principal Balance (CNY)",
  lang95: "Please Complete Payment Actions in Sequence",
  lang96: "Click Here",
  lang97: "Proceed to Complete Payment on Redirected Webpage",
  lang98: "After Payment, Copy Payment Transaction ID and Enter Below",
  lang99: "Enter Payment Transaction ID",
  lang100: "Upload Payment Proof Image",
  lang101: "Click to Upload",
  lang102: "Confirm Upload",
  lang103: "Maximum 1 Uploading Image; Please Delete First, Then Upload",
  lang104: "Please Enter Transaction ID",
  lang105: "Please Upload Payment Proof",
  lang106: "Please Check the Order",
  lang107: "Transaction Price",
  lang108: "Price",
  lang109: "CNY",
  lang110: "Total Product Price",
  lang111: "Actual Delivery Weight",
  lang112: "Service Fee",
  lang113: "Order Number",
  lang114: "Copy",
  lang115: "Creation Time",
  lang116: "Payment Method",
  lang117: "Cancel",
  lang118: "Confirm Payment",
  lang119: "Contract List",
  lang120: "Refresh",
  lang121: "Contract Name",
  lang122: "Status",
  lang123: "Unsigned",
  lang124: "Signing in Progress",
  lang125: "Signing Completed",
  lang126: "Operation",
  lang127: "Go to Sign",
  lang128: "View Contract",
  lang129: "Batch Signing",
  lang130: "Online contract signing SMS has been sent...",
  lang131: "Receiving Phone Number",
  lang132: "Please check your text messages and sign promptly.",
  lang133: "I Understand",
  lang134: "Supply Registration Details",
  lang135: "Supply Name",
  lang136: "Unit",
  lang137: "Weight",
  lang138: "Place of Origin",
  lang139: "Supply Description",
  lang140: "Registration Number",
  lang141: "Submission Time",
  lang142: "Rejection Time",
  lang143: "Confirmation Time",
  lang144: "Apply for Pickup",
  lang145: "Total Tonnage",
  lang146: "In-process Pickup Tonnage",
  lang147: "Picked-up Tonnage",
  lang148: "Remaining Available Tonnage",
  lang149: "Pickup Record",
  lang150: "Pickup Status",
  lang151: "Estimated Pickup Tonnage",
  lang152: "Actual Outbound Tonnage",
  lang153: "Pickup Date",
  lang154: "Outbound Date",
  lang155: "Application Time",
  lang156: "Amount Payable",
  lang157: "Cost Details",
  lang158: '"Expense Confirmation Document"',
  lang159: "Outbound Order",
  lang160: 'Fill in the "Expense Confirmation Document"',
  lang161: 'Pay After Viewing "Fee Confirmation Form"',
  lang162: "Upload Outbound Order",
  lang163: "All",
  lang164: "Waiting for Seller to Return Expense Confirmation Document",
  lang165: "Waiting for Buyer to Pay",
  lang166: "Waiting for Seller to Upload Outbound Form",
  lang167: "Pickup Completed",
  lang168: "Upload Successful",
  lang169: "Fill in Fee Confirmation Form",
  lang170: "Buyer Application",
  lang171: "Buyer Customer",
  lang172: "Estimated Pickup Date",
  lang173: "Cold Storage Location",
  lang174: "Benchmark Date",
  lang175: "Expense Confirmation Document",
  lang176: "Available Pickup Date",
  lang177: "Select Date",
  lang178: "Days",
  lang179: "Quantity of Packages",
  lang180: "Click to Enter Positive Integer",
  lang181: "Gross Weight (tons)",
  lang182: "Click to Enter Number (Supports 4 Decimal Places)",
  lang183: "Net Weight (tons)",
  lang184: "Transaction Price (CNY/ton)",
  lang185: "CNY/ton (Non-adjustable)",
  lang186: "Payment for Goods(CNY)",
  lang187: "Automatically Calculated by System (No Need to Fill)",
  lang188: "Advance Payment (CNY)",
  lang189: "Reset",
  lang190: "Base Price Increase",
  lang191: "Click to Fill",
  lang192: "Storage Fee",
  lang193: "Outbound Handling Fee",
  lang194: "Insurance Premium",
  lang195: "Click to Enter Number (Supports 2 Decimal Places)",
  lang196: "Other",
  lang197: "Please Enter Negative Number to Reduce Buyer's Payment Fee",
  lang198: "Total Amount Payable (CNY)",
  lang199: "Preview Image",
  lang200: "Send Expense Confirmation Document",
  lang201: "Expense Confirmation Document Preview",
  lang202: "Return to Modify",
  lang203: "Send to Buyer",
  lang204: "Please Enter Number of Packages",
  lang205: "Please Enter Integer",
  lang206: "Please Enter Base Price Increase",
  lang207: "Please Enter Net Weight (tons)",
  lang208: "Please Enter Storage Fee",
  lang209: "Please Enter Outbound Handling Fee",
  lang210: "Please Enter Insurance Premium",
  lang211: "Please Enter Other Fees",
  lang212: "Sent Successfully",
  lang213: "Storage Fee Unit Price",
  lang214: "Outbound Handling Fee Unit Price",
  lang215: "Not to Exceed Remaining Inventory",
  lang216: "Confirm Pickup",
  lang217: "Generate",
  lang218: "Starting Soon",
  lang219: "Transaction has been completed",
  lang220: "Fail to Sell (at Action)",
  lang221: "In Progress",
  lang222: "Port of Arrival",
  lang223: "Place of Delivery",
  lang224: "Divisible",
  lang225: "Remaining",
  lang226: "Starting Bid Price",
  lang227: "USD",
  lang228: "Exclusive Customer Service",
  lang229: "Contact Quality Control",
  lang230: "View Seller's Supply",
  lang231: "Start Payment",
  lang232: "Already Loaded",
  lang233: "Confirm Loading",
  lang234: "Please Call:",
  lang235: "Confirm",
  lang236: "File Download Failed",
  lang237: "File Signing Failed",
  lang238: "Uploaded By",
  lang239: "No Price Yet",
  lang240: "Please Enter Content",
  lang241: "Remove from Listing",
  lang242: "Place Another Order",
  lang243: "Edit and Relist",
  lang245: "View Order",
  lang246: "Relist",
  lang247: "Delete",
  lang248: "Modify Price",
  lang249: "Confirm Modification",
  lang250: "Apply to Supply",
  lang251: "Edit",
  lang252: "This action will remove this supply from listing. Continue?",
  lang253: "Prompt",
  lang254: "Successfully Removed!",
  lang255: "This action will delete this supply. Continue?",
  lang256: "Successfully Deleted!",
  lang257: "Starting Soon",
  lang258: "Supply",
  lang259: "Remarks",
  lang260: "Current Price",
  lang261: "Deal Closed",
  lang262: "Starting Bid",
  lang263: "Start Bidding",
  lang264: "End",
  lang265: "Time Until Start",
  lang266: "Time Until End",
  lang267: "Pin to Top",
  lang268: "Quote in Progress",
  lang269: "Current",
  lang270: "I Want to Reduce Price",
  lang271: "I Want to Increase Price",
  lang272: "Latest Price",
  lang273: "Price Increment",
  lang274: "Bidder",
  lang275: "New Registration",
  lang276: "Please Select Bidder",
  lang277: "Bid Confirmed",
  lang278: "Bind Bank Card",
  lang279: "Account Type",
  lang280: "Account Name",
  lang281: "Bank Card Number",
  lang282: "Please Enter",
  lang283: "Bank",
  lang284: "Account-opening Branch",
  lang285: "Bank-registered Phone Number",
  lang286: "Submit",
  lang287: "Card Changed Successfully",
  lang288: "Bank Transfer",
  lang289:
    "Suzhou Commercial Bank will make a transfer to the provided corporate account",
  lang290:
    "After completing the transfer, please fill in the information based on the transfer amount",
  lang291: "Please Select Account Type",
  lang292: "Please Enter Bank Card Number",
  lang293: "Please Select Bank",
  lang294: "Please Select Branch",
  lang295: "Please Enter Phone Number",
  lang296: "Cardholder",
  lang297: "Select Entity",
  lang298: "Purchase Quantity",
  lang299: "Purchase Quantity Not Less Than",
  lang300: "Please Enter Account Password",
  lang301:
    "This operation does not involve any transfer and is used to confirm purchase intention only",
  lang302: "Reset Password",
  lang303: "No Password Yet",
  lang304: "Go to Settings",
  lang305: "Transaction Prompt: This order supports online payment",
  lang306: "Transaction Request Queued",
  lang307: "There are ** customers ahead of you in the transaction queue.",
  lang308:
    "Our staff will contact you soon. Please pay attention to incoming calls.",
  lang309: "I Understand",
  lang310: "Please Select Customer",
  lang311: "Please Select Entity",
  lang312: "Please Enter Purchase Tonnage",
  lang313: "Add Entity",
  lang314: "Switch Entity",
  lang315: "Add New Entity",
  lang316: "Please Enter Payment Password",
  lang317: "Payment Method",
  lang318: "Suzhou Commercial Bank",
  lang319: "No Relevant Data Available",
  lang320: "Process Quotation",
  lang321: "My Quotations",
  lang322: "Quotation (USD/ton)",
  lang323: "Subscribed Tonnage (tons)",
  lang324: "Delete Quotation",
  lang325: "Submit Quotation",
  lang326: "Customer",
  lang327: "Quotation",
  lang328: "Time",
  lang329: "Reject",
  lang330: "Deal Closed",
  lang331: "Hide This Processing Result",
  lang332: "Submit Processing Result",
  lang333: "Please Enter Quotation",
  lang334: "Please Enter Subscribed Tonnage",
  lang335: "Submitted Successfully",
  lang336: "Processed Successfully",
  lang337: "Q&A Frequently Asked Questions",

  lang338:
    "The platform has final interpretation rights regarding all related matters. For any questions, please call 400-101-2799.",
  lang339: "I have read and fully understand the above content",
  lang340: "How exactly are buyer service fees charged?",
  lang341: "The buyer service fee is charged at 100 CNY/ton.",
  lang342: "How exactly are buyer service fees charged?",
  lang343: "The buyer service fee is charged at 50 CNY/ton.",
  lang344: "How exactly are buyer service fees charged?",
  lang345: "The buyer service fee is charged at 1 CNY/box.",

  lang346:
    "In dynamic bidding, the system will continuously bid based on the number of bidders until only 1 bidder remains (in most cases),and at this point the bidding ends.",

  lang347:
    "In regular bidding, if a new bid is placed within the final 1-minute countdown, it enters extended bidding with a 1-minute extension. If another new bid is placed within this extended 1-minute countdown, the 1-minute countdown restarts. This process repeats until no further bids are placed before the countdown ends. The highest bidder wins.",
  lang348: "Is a security deposit mandatory?",

  lang349:
    "To protect all platform users' rights, both sellers and buyers must pay a certain security deposit amount before participating in platform transactions. Sellers need to pay a 2% security deposit of the goods' value when posting transactions, while buyers need to pay a certain security deposit amount when applying for bidding transactions (usually set by the seller during posting). All deposits are paid online; offline payments are not supported.",
  lang350: "When will the security deposit be refunded?",

  lang351:
    "If you are a seller, the security deposit will be refunded if you voluntarily delete supply before transaction or fulfill obligations after transaction. If you are a buyer, the security deposit will be promptly refunded if you don't win the bid; if you win, it will be refunded after you complete your obligations.",
  lang352: "How to confirm everyone has finished bidding?",
  lang353: "How are default cases handled?",

  lang354:
    "After completing transaction, if either party breaches the contract, in addition to following customer complaint procedures and security deposit penalty, the trader will be added to the platform's blacklist, affecting or restricting participation in future transactions.",
  lang355: "Second",
  lang356: "Agree and Continue",
  lang357: "Quickly Find Supply",
  lang358: "Prospective Supply",
  lang359: "Message Board",
  lang360: "Help Me Find",
  lang361: "Request Sent",
  lang362: "A specialist will contact you soon",
  lang363: "Please pay attention to incoming calls",
  lang364: "Working Hours: Monday to Saturday",
  lang365: "Understand",
  lang366: "Please select prospective supply",
  lang367: "Please enter message content",
  lang368: "Password Setup",
  lang369: "Please enter password",
  lang370: "Please confirm by re-entering",
  lang371: "Entries don't match, please re-enter",
  lang372: "Successfully modified",
  lang373: "Apply to",
  lang374: "Entity",
  lang375: "Quantity",
  lang376: "Account Password",
  lang377: "No password yet, go to setup",
  lang378: "Supply Address",
  lang379: "Supply Sample Photos/Videos",
  lang380: "Click to upload",
  lang381: "Supply Description",
  lang382: "Friendly Reminder",
  lang383:
    "Please wait a second as the transaction is being urgently confirmed. Our staff will contact you soon - please pay attention to incoming calls.",
  lang384: "Video Playback",
  lang385: "Please enter numbers",
  lang386: "Please select supply address",
  lang387: "Please enter supply description",
  lang388: "Maximum 9 images allowed",
  lang389: "Current Bid Security Deposit Amount",
  lang390: "Your Account Balance",
  lang391:
    "Apply for bidding indicates agreement to freeze the corresponding security deposit;",
  lang392:
    "If fail to win the bid, frozen security deposits will be automatically refunded;",
  lang393:
    "If win the bid, frozen security deposits will be refunded after order confirmation;",
  lang394:
    "If you fail to fulfill obligations after winning the bid, frozen security deposits will be deducted.",
  lang395: "Cancel Apply",
  lang396: "Transfer to",
  lang397: "Need More Time to Consider",
  lang398: "Confirm Apply",
  lang399: "Please select an entity first",
  lang400: "Apply Canceled",
  lang401: "Must-Watch Demo for Beginners",
  lang402:
    "Opening Hours: Monday to Saturday (excluding holidays) 9:00-11:30 13:00-16:30",
  lang403: "Market Open Today",
  lang404: "Market Closed Today",
  lang405: "No Bidding All Day",
  lang406: "Market Closed All Day, No Sessions Scheduled",
  lang407: "Squid Zone",
  lang408: "Cod Zone",
  lang409: "White Shrimp Zone",
  lang410: "Board",
  lang411: "Beginner Tutorial",
  lang412: "Composite Index",
  lang413: "Route Code",
  lang414: "Market Price",
  lang415: "Market News",
  lang416: "Overall Market Price",
  lang417: "Regional Price",
  lang418: "Historical Price",
  lang419: "All Brands",
  lang420: "to",
  lang421: "Start Date",
  lang422: "End Date",
  lang423: "CNY",
  lang424: "USD",
  lang425: "Price Trend Chart",
  lang426: "Region",
  lang427: "Unit: (CNY/ton)",
  lang428: "tPrice",
  lang429: "Closing Price",
  lang430: "Highest Price",
  lang431: "Lowest Price",
  lang432: "Average Transaction Price",
  lang433: "Price Range",
  lang434: "Country",
  lang435: "**Updated",
  lang436: "Month",
  lang437: "Day",
  lang438: "Background of the BRICS Countries Project and the Trading Center",
  lang439: "The Origin of BRICS Cooperation",
  lang440:
    " Strategic Significance for the Establishment of an Aquatic Products Trading Center:",
  lang441: " Background of the Establishment of the Trading Center",
  lang442: "Positioning and Objectives of the Trading Center ",
  lang443: " From a Concept to the Rise of a Major Global Economic Force",

  lang444:
    ' In 2001, as the global economic landscape was undergoing subtle yet profound changes, Jim O\'Neill, once the chief economist at Goldman Sachs, firstly put forward the visionary concept of "BRIC countries" in a research report. At that time, he astutely observed the potentiality of four countries—Brazil, Russia, India, and China—in the global economy. Combining the first letters of their English names, he formed the acronym "BRIC". Since this abbreviation sounds nearly identical to the English word "brick", the term “jīn zhuān sì guó” came into being. It vividly symbolizes how these four nations, like solid bricks, would help building up the edifice of the global economy.',

  lang445:
    "The proposal of the \"BRIC\" concept was no historical accident. Back then, all four countries were showing strong momentum of economic growth: Brazil, leveraging its abundant natural resources and agricultural strengths, was emerging as a standout economy in Latin America; Russia, relying on energy exports and its foundation in military industry, was gradually emerging from an economic trough; with its software and service industry as dual engines, India was embarking on a chapter of rapid development; and China, by deepening reform and opening up, was becoming a pivotal global manufacturing base and a core driver of global economic growth. O'Neill's concept accurately captured the trend of the rise of emerging market economies, providing a novel perspective for global economic observation",

  lang446:
    ' In 2006, during the United Nations General Assembly, the foreign ministers of Brazil, Russia, India, and China held their first meeting. Though seemingly low-profile, this meeting bore milestone significance, marking the commencement of substantive cooperation among the "BRIC countries." Since then, cooperations among the four countries across politics, economy, finance, and other fields have deepened continuously, gradually institutionalizing regular consultation mechanisms. They have worked together to address global economic challenges and safeguard the common interests of emerging markets.',

  lang447:
    ' In 2010, South Africa officially joined the "BRIC countries," marking a pivotal enhancement to the cooperation mechanism and changing the acronym from "BRIC" to "BRICS". South Africa\'s accession not only expanded the geographical coverage of BRICS, extending its influence to the African continent, but also enriched the connotation of BRICS cooperation. From then on, the BRICS cooperation mechanism officially took shape, BRICS had become an emerging force that cannot be overlooked on the global stage. ',
  lang448:
    " BRICS countries occupy a pivotal position worldwide. In terms of land area, the total land area of BRICS countries accounts for 26.46% of the world's total territorial area, with vast lands harboring abundant natural resources that provide a solid material foundation for economic development. Demographically, BRICS countries accounted for 41.93% of the global population. This immense population not only meant vast market potential but also provided sufficient labor resources for global economic development.",
  lang449:
    " Over time, the BRICS countries have steadily amplified their influence within the global economic landscape. As of 2023, when measured by purchasing power parity (PPP), the BRICS countries accounted for 35.7% of global GDP—surpassing the G7's 29%. This remarkable shift underscored the BRICS's growing economic heft and reflected the trend of gradual transition of global economic gravity from advanced economies toward emerging markets. Today, BRICS countries have become a pivotal force in driving global economic growth and promoting international cooperation and multilateralism. In the future, BRICS countries will continue to deepen cooperation, address various global challenges jointly, and contribute to build a more equitable and rational international economic order.",
  lang450:
    " Today, BRICS countries have become a pivotal force in driving global economic growth and promoting international cooperation and multilateralism. In the future, BRICS countries will continue to deepen cooperation, address various global challenges jointly, and contribute to build a more equitable and rational international economic order.",
  lang451:
    " BRICS Aquatic Products Trading Center: A Critical Engine for Fisheries Cooperation and Development",

  lang452:
    " Against the backdrop of deepening cooperation among BRICS countries, the establishment of an aquatic products trading center has become a crucial initiative to promote synergistic development in the fisheries sector. Our platform plays an irreplaceable role in boosting trade growth, optimizing resource allocation, and strengthening industrial collaboration, injecting robust momentum into the flourishing development of aquatic products trade among BRICS countries.",

  lang453:
    " From the perspective of trade promotion, the trading center can effectively integrate resources from member countries, substantially reduce trade barriers, and further enhance the volume of aquatic products trade within BRICS countries. Each BRICS country possesses unique aquatic resources: Brazil produces abundant freshwater fisheries from tropical rainforests and diverse marine products along its extensive coastline; Russia is rich in high-quality cold-water fish from the Arctic and Far Eastern seas; India offers a wide variety of tropical aquatic products with substantial yields; China holds a dominant position in farmed aquatic products; and South Africa’s marine fisheries resources are extremely distinctive. By setting up a unified information-sharing platform, the trading center consolidates supply information, market demand, and regulatory policies etc from all countries, enabling buyers and sellers to connect swiftly and accurately. Moreover, the center can facilitate agreements on tariff reductions, mutual recognition of inspection and quarantine standards, thereby simplifying customs clearance procedures and lowering trade costs. For instance, previous discrepancies in inspection standards of BRICS countries hindered cross-border trade for certain aquatic products. The trading center can address this by coordinating experts to establish unified industry standards, allowing premium products like Brazil’s tuna, Russia’s cod, India’s shrimp, and China’s eel to circulate freely among BRICS countries in order to substantially increase trade volumes.",

  lang454:
    " In terms of optimizing resource allocation, the trading center leverages its platform function to ensure a much more efficient distribution of advantageous aquatic products from all countries, achieving rational resource allocation. BRICS countries exhibit obvious complementarity in production and consumption. For example, China has a strong demand for cold-water fish, which Russia supplies in abundance. While Brazil’s market favors farmed shrimp, India is the major producer. Through big data analytics, the trading center precisely tracks market trends, guiding the flow of aquatic products according to the market laws. When India experiences a surplus in shrimp production, the center will promptly transmit the information to Brazil’s high-demand market and facilitate the transactions. Similarly, when China’s farmed aquatic output exceeds domestic needs, the center will facilitate exports to Russia and other countries that are interested in it. This efficient circulation mechanism prevents resource idleness and wastage, ensuring each country’s premium products exert their value in the places where they are required mostly and optimizing resource distribution across BRICS countries.",

  lang455:
    " The trading center also plays a remarkably significant role in strengthening industrial cooperation. It can drive synergy across upstream and downstream sectors, and deepen collaboration of all BRICS countries within the fishery industrial chain. The prosperity of aquatic trade extends beyond transactions, encompassing aquaculture, processing, logistics, and related upstream and downstream industries. The center serves as a bridge for coordinated development of these industries. In aquaculture, members can share advanced techniques—such as China’s rice-fish farming or Brazil’s eco-friendly models—to elevate industry standards through the trading center. In the processing industry, the trading center can foster cooperation among processing enterprises from various countries. Russia’s fish processing technology and China’s experience in intensive processing can complement each other’s advantages, enhancing the added value of aquatic products. In the logistics industry, to satisfy the needs of aquatic product preservation and rapid transportation, logistics enterprises from different countries can jointly build a cross-border cold chain logistics network, with the trading center providing a coordination platform for the integration of logistical resources. Through the synergistic development of these upstream and downstream industries, cooperation among BRICS countries in the fishery industrial chain continues to deepen, forming an interdependent and mutually beneficial industrial ecosystem.",
  lang456:
    " The establishment of BRICS Aquatic Products Trading Center represents a critical practice to meet fisheries development needs and deepen cooperation of all BRICS countries. By playing multifaceted roles, it not only drives trade expansion but also promotes deeper integration in the fisheries sector, paving the way for a prosperous future in the aquatic industries of BRICS countries.",
  lang457:
    " BRICS Aquatic Products Trading Center: A Solid Foundation for Its Establishment and the Inevitability of Its Occurrence",

  lang458:
    " The BRICS countries possess immense potential for cooperation in the fisheries sector. The establishment of an aquatic products trading center emerges as a natural selection of both resource endowments and market demands of them all, and a necessary measure to enhance global competitiveness and deepen institutional collaboration. The establishment of this platform is based on robust practical foundations and carries profound contemporary significance.",

  lang459:
    " The vast potential of BRICS countries in fisheries resources and aquatic markets provides a solid material foundation for the establishment of trading center. Aquatic products from each country have their own characteristics and possess extremely strong complementarity, this creates a natural bond for cooperation. Russia’s expansive Arctic and Pacific maritime area abound in deep-sea fish resources, with cold-water species like cod and salmon renowned globally for their exquisite texture and nutrient-rich value. China has accumulated mature freshwater aquaculture technology from rice-fish farming to industrialized aquaculture, delivering consistent output and quality. Its products and product quality have long remained at the world's forefront. Meanwhile, the aquatic processing industrial chain is well-developed and capable of converting primary products into diversified deep-processed products. India lies in the tropical zone, and its unique climate conditions have nurtured abundant tropical aquatic products, fostering unique species such as shrimp, tilapia etc with substantial yields, which is highly favored by the international market. Brazil’s Amazon River Basin and long coastline yield abundant freshwater fishes and marine products, while South Africa’s surrounding maritime areas offer premium delicacies with unique regional characteristics like lobster and abalone. This diversity and complementarity of resources enable each country to obtain what they need, providing sufficient trading targets and vast market space for the operation of the trading center. This has enabled cross-country and cross-category aquatic product circulation to possess inherent advantages.",

  lang460:
    " Amid a global aquatic trade market marked by both competition and opportunity, BRICS countries urgently require a unified, efficient trading platform to bolster their collective competitiveness and amplify their voice in international markets. Currently, the global aquatic product trade pattern is complex, having technical barriers and trade protectionism in traditional markets including the EU, Japan and so on, as well as fierce competition from Southeast Asia countries in mid-to-low-end segments. While each BRICS member possesses competitive products, fragmented trade model makes it difficult to form synergy. In aspects such as price negotiations, standard setting, and other related areas, they often find themselves in a passive position. For instance, China’s farmed aquatic products and Russia’s deep-sea fish, despite their global appealing competitiveness, often fall prey to price manipulation by international capital and middlemen due to the lack of an unified price negotiation platform. A consolidated trading center would integrate export resources from all countries, achieve scale effect, and enhance bargaining ability through centralized procurement and joint negotiations. In the meantime, it could also establish unified quality certification system and branding mechanisms, Enabling the aquatic products of BRICS countries to participate in international competition as an integrated entity, and thus, securing greater says in the formulation of global trade rules and better capitalizing on opportunities arising from the consumption upgrade in global aquatic products.",

  lang461:
    " With the continuous improvement of the BRICS cooperation mechanism and achieved remarkable achievements in economic, trade, and financial cooperation, the establishment of an aquatic products trading center has become an important measure to further deepen practical collaboration. In recent years, economic and trade cooperation among BRICS countries has continued to intensify, with trade volumes rising year by year. Financial institutions such as the New Development Bank and so on have provided strong support for cross-border trade. Against the backdrop of this positive momentum, the fisheries sector, as a vital component of each country’s economy, urgently requires a specialized platform to harness the benefits of cooperation. Previously, BRICS members have accumulated extensive experience in areas such as agricultural trade and energy cooperation, these successful practices offer valuable models for the operation of the aquatic products trading center.  The establishment of this trading center will extend the achievements of BRICS economic and financial cooperation into the fisheries sector. By streamlining logistics channels, simplifying settlement procedures, sharing market information and so on, practical cooperation can be effectively implemented. This will not only enrich the connotation of BRICS countries’ collaboration but also drive the development of related industries through the synergy of the fisheries supply chain, injecting new momentum into economic growth for member countries. It serves as a vivid footnote to the “quality-upgrading” of BRICS cooperation.",

  lang462:
    " In summary, the establishment of the BRICS Aquatic Products Trading Center is the result of complementary resource endowments, market demand, and deepened cooperation. Its launch will enhance the efficient integration of fishery resources among member countries, boost global competitiveness, and open up broader prospects for collaboration of BRICS countries.",
  lang463:
    " Positioning and Objectives of the BRICS Aquatic Products Trading Center",

  lang464:
    " Positioned as a globally leading centralized trading platform for aquatic products among BRICS countries, the BRICS Aquatic Products Trading Center features a diversified functional system. It integrates multiple services—including information dissemination, transaction matching, quality inspection, logistics distribution, and financial support—into a complete closed loop for aquatic product trade services.",

  lang465:
    " In terms of information services, the platform consolidates real-time data on supply and demand, price fluctuations, and policy updates across BRICS countries, offering enterprises accurate market insights. The transaction matching function operates through an intelligent system to break geographical barriers, efficiently connect buyers and sellers, and streamline  trading procedures. Quality inspection is conducted under a unified standard framework to test strictly on imported and exported aquatic products to ensure safety. The logistics and distribution network incorporates resources from member countries to establish cross-border cold chain channels that maintain product freshness. The financial services sector involves institutions such as the New Development Bank of the BRICS and so on, providing services of settlement, financing, insurance etc, and solutions to address capital-related challenges in trade.",

  lang466:
    " The core mission of the Trading Center is to serve as a pivotal hub for fisheries economic cooperation within BRICS countries. By integrating member states’ fisheries resources, promoting collaboration across upstream and downstream industry chains, facilitating technological exchanges and standards alignment, it aims to achieve deep integration of the BRICS fisheries economy. In the future, the Center will function as a dialogue platform for policy coordination, a bridge for enterprise collaboration, and a critical node in global aquatic product trade. It will facilitate BRICS countries in forging synergy in the fisheries sector, enhance overall competitiveness, and contribute to the sustainable development of global fishery industry.",
  lang467: "Platform Rules",
  lang468: "BRICS International Fisheries Trading Platform",
  lang469:
    " To build a world-leading aquatic product trading platform for BRICS countries and promote international trade cooperation and development ",
  lang470: "Trade Now",
  lang471: "Import Solutions",
  lang472: "Overseas Agency Import Services",

  lang473:
    "The main import categories are: aquatic product imports (Including white shrimp, fish, crab, etc.), meat product imports (Including beef, mutton, pork, etc.), and poultry imports (including chicken, duck, goose, etc.).",
  lang474: "Procurement Agent | Inquiry & Price Negotiation",
  lang475: "Payment Agent | Cross-border Remittance",
  lang476: "Customs Clearance Agent | Import Customs Clearance",
  lang477: "Logistics Agent | Logistics Tracking",
  lang478: "Warehousing Agent | Warehousing Resources",
  lang479: "Four Flows Integrated · Whole Process Visible",
  lang480: "Providing one-stop professional import aquatic trade solutions",
  lang481: "Information Flow",
  lang482: " Overseas Premium Aquatic Products Recommendation",
  lang483: " Overseas Service Provider Resources ",
  lang484: "Domestic Aquatic Product Demand Matching",
  lang485: "Capital Flow",
  lang486: "Foreign Currency Remittance Qualification",
  lang487: " Advance Business Payment ",
  lang488: "Supply Chain Financial Services",
  lang489: "Logistics",
  lang490: " International Shipment Tracking ",
  lang491: " Real-time Cold Chain Logistics ",
  lang492: " Optimal Route Decision-making ",
  lang493: "Service Flow",
  lang494: "Smart Contract",
  lang495: "Service Process Visibility",
  lang496: "Digital Services",
  lang497: "Business Advantages",
  lang498:
    " Focus on the trade of imported aquatic products and frozen goods, with the composite import volume of white shrimps leading the nation ",

  lang499:
    " We specialize in import agency and procurement services for aquatic products and frozen goods. We have access to a large number of overseas supplier resources for aquatic products and frozen goods, and a team of professional and experienced foreign trade consultants to negotiate quotations. Our stable supply channels and strong bargaining power make the procurement process more cost-effective, efficient and fast, enabling us to truly help customers save money. ",
  lang500:
    " One-stop import agency & procurement services, easily achieving global buying and selling",

  lang501:
    "Holding legal & compliant import-export rights and foreign remittance qualifications. With professional multi-to-one VIP follow-up services, we enable real-time tracking of the entire process of import orders, featuring information visualization, logistics visualization, and fund visualization. Our robust bulk aquatic products trading center provides sales channel resources, offering a one-stop service from buying to selling, making aquatic transactions more hassle-free and labor-saving.",
  lang502: "Market Closed",
  lang503: "Opening Hours:  Monday to Saturday, 9:00 a.m. - 5:00 p.m.",
  lang504: "Consolidated orders",
  lang505: "Listing",
  lang506: "Bidding",
  lang507: "Transaction Type",
  lang508: "Order",
  lang509: "Zone",
  lang510: "All Zones",
  lang511: "Sort",
  lang512: "Filter",
  lang513: "Category/Item/Size",
  lang514: "Comprehensive Sorting",
  lang515: "Price from Low to High",
  lang516: "Price from High to Low",
  lang517: "All Statuses",
  lang518:
    "Hello, welcome to log in to BRICS (Xiamen) International Fisheries Trading Center",
  lang519: "Verification Code",
  lang520: "Mobile Number",
  lang521: "Get Verification Code",
  lang522: "Resend in **S",
  lang523: "Password",
  lang524: "I Have read and agree to",
  lang525: "Incorrect mobile number format",
  lang526: "Please enter verification code",
  lang527:
    "Please read and agree to the 'Personal Information Protection and Privacy Policy', 'User Service Agreement', 'Information Service Agreement',  'Trail Use of Overall Rules Summary '",
  lang528: "Loading...",
  lang529: "Original",
  lang530: "Semi-",
  lang531: "Sold",
  lang532: "Production Date",
  lang533: "Fishing Time ",
  lang534: "Year",
  lang535: "Fishing Method",
  lang536: "Frozen",
  lang537: "Fishing Area",
  lang538: "Packaging Method",
  lang539: "Cut",
  lang540: "With Membrane or Not",
  lang541: "Select and Use This Record",
  lang542: "Supply Source Details",
  lang543: " Source Supplier ",
  lang544: "Source Supplier clients ",
  lang545: " Vessel Number",
  lang546: "Cold Storage",
  lang547: " Whether the supply is shipped via charter",
  yes: "Yes",
  no: "No",
  lang548: "Self-operated Attribute",
  lang549: "Open",
  lang550: "Non-open",
  lang551: "Number/ID",
  lang552: "Brand",
  lang553: "More Information",
  lang554: "Other Supplementary Information",
  lang555: "Tuna",
  lang556: " Imported Peruvian Squid",
  lang557: "Please enter keywords...",
  lang558: "Search",
  lang559: "By Customer",
  lang560: "By Specification",
  lang561:
    "To add new self-operated supply sources, please go to the Small Blackboard to add",
  lang562: "Sold Out",
  lang563: "Balance",
  lang564: "Update Time",
  lang565: "Unit: ton",
  lang567: "Circulation Alert",
  lang568: "Awaiting Circulation",
  lang569: "Total:",
  lang570: "Sold",
  lang571: "Total Quantity",
  lang572: "Current Person in Charge",
  lang573: "All News",
  lang574: "Hottest in Last 7 Days",
  lang575: "Hottest Historically",
  lang576: "Related News",
  lang577: "More News",
  lang578: "Start",
  lang579: "Bidding in Progress...",
  lang580: "Countdown",
  lang581: "Current Round Countdown",
  lang582: "Time until start",
  lang583: "Decision Time",
  lang584: "Bidding Ended",
  lang585: "Not Divisible",
  lang586: "Current Round Price",
  lang587: "** people registered",
  lang588: "** views",
  lang589: "** purchase requests",
  lang590: "Estimated arrival at @@ at ** ",
  lang591: "Country of Origin",
  lang592: "Selling Method",
  lang593: "Package Weight",
  lang594: "Number of Box(es) ",
  lang595: "Production Time",
  lang596: "Stock-in Time",
  lang597: "Freezing Method",
  lang598: "Cutting Method",
  lang599: "Specification Proportion and Size",
  lang600: "Packaging Type",
  lang601: "Payment Mode",
  lang602: "Deposit Mode",
  lang603: "Deposit ** CNY",
  lang604: "Full Payment Mode",
  lang605: "Order Description",
  lang606: "Fold",
  lang607:
    "The buyer needs to pay additional platform service fee, the charging standard is",
  lang608: "Actual fees determined based on specific circumstances",
  lang609:
    "If financial support is needed, please contact platform customer service for consultation",
  lang610: "This order supports financial payment",

  lang611:
    "This order supports financial payment services. If you have an advance payment requirement, you can fill out the advance payment application form during the your purchase. After submitting the application, the bank will evaluate and review your application according to relevant standards and processes. Upon approval and obtaining credit, you can receive advance payment support equivalent to 70% of the purchase payment amount so as to successfully complete this transaction.",
  lang612: "Are there any other supply sources?",
  lang613: "Ask for it",
  lang614: "Opening Hours",
  lang615: "Regular Payment",
  lang616: "Financial Payment",
  lang617: "This order supports online payment",
  lang618: "I want to register",
  lang619: "Please wait for the next round",
  lang620: "Accept the price! Follow!",
  lang621: "Cancel Follow-up Bidding",
  lang622: "Confirm Follow-up Bidding",
  lang623: "Call the Broker by Phone",
  lang624: "Contact the Exclusive Broker",
  lang625: "Get Detailed Information",
  lang626: "Goods Label Interpretation Report",
  lang627: "Goods Label Interpretation Video",
  lang628: "Bidding History",
  lang629: "Serial Number",
  lang630: "Status",
  lang631: "Leading",
  lang632: "Out",
  lang633: "Bidder",
  lang634: "Me",
  lang635: "Change",
  lang636: "Price After Change",
  lang637: "Change Time",
  lang638: "Number of Follow-up Bidders",
  lang639: "(Followed)",
  lang640: "Offer Details",
  lang641: "Just View Mine",
  lang642: "Subscribed Tonnage",
  lang643: "Edit Offer",
  lang644: "Transaction Details",
  lang645: "Import Consolidated Order ",
  lang646: "Transaction Number",
  lang647: "Bid Increment",
  lang648: "Auction Time",
  lang649: "Auction Duration",
  lang650: "minutes",
  lang651: "The time for considering whether to follow the bid in each round.",
  lang652: "seconds",
  lang653: "Delay Period",
  lang654: "Upload Time",
  lang655: "Transaction Time",
  lang656: "Internal Customer",
  lang657: "Customer Entity",
  lang658: "Scheduled Listing",
  lang659: "Supply Source Inventory List",
  lang660: "Viewable after transaction confirmation",
  lang661: "Total ** sheets",
  lang662: "Outer Packaging Bag",
  lang663: "Download All Images with One Click",
  lang664: "Supply Source Tags",
  lang665: "Supply Source Images/Videos",
  lang666: "Quality Control Report",
  lang667: "Qualification Procedures",
  lang668: "Dynamic Bidding Rules",
  lang669: "Bidding Process",

  lang670:
    "Each round of bidding starts with a system bid. After the bid is made, buyers will have <span>** seconds</span>  to decide whether to follow the bid.",
  lang671: "Situation of No Follow-up Bids",

  lang672:
    "If no buyer chooses to follow the bid within the specified <span>** seconds</span>, the bidding will proceed to the next round, and the price for the next round will decrease.",
  lang673: "Situation of Multiple Follow-up Bids",

  lang674:
    "If multiple buyers choose to follow the bid within <span>** seconds</span>, the bidding also proceeds to the next round, and the price for the next round will increase.",
  lang675: "Special Judgment Rules",

  lang676:
    "If there are two consecutive instances where the same lowest price receives multiple follow-up bids, and no subsequent bids are placed for higher prices, then when this low price appears for a third time, the buyer who places the follow-up bid first will win the auction",
  lang677: "Reserve Price Principle",

  lang678:
    "During the bidding process, the transaction will fail if the price continues to decrease due to no follow-up bids and at the same time it reaches or falls below the pre-set reserve price with still no follow-up bids.",
  lang679: "Uniform Price Validity",

  lang680:
    "In this bidding, regardless of the session, once a buyer follows a bid at a certain price, that follow-up bid remains valid. This means that once a price is followed by a buyer, this price will participate in the entire bidding system as a valid price in subsequent bidding processes until final transaction or failure.",
  lang681: "Contact Person",
  lang682: "Contact Information",
  lang683: "Congratulations for Winning the Bid",
  lang684: "Order Confirmation in Progress",
  lang685: "Follow-up Bid Details",
  lang686: "Follow-up Bid Sequence",
  lang687: "Inherit",
  lang688: "Close",
  lang689: "Box",
  lang690: "Package",
  lang691: "Supply Source Photos",
  lang692: "Outer Packaging",
  lang693: "Label",
  lang694: "Registration Successful",
  lang695: "Select Category",
  lang696: "Select Transaction Type",
  lang697: "Next Step",
  lang698: "Self-operated Resources",
  lang699: "Viewing Record",
  lang700: "Order Settings",
  lang701: "Supply Source Settings",
  lang702: "Item Number",
  lang703: "Clear",
  lang704: "Order Name",
  lang705: "Tonnage",
  lang706: "Fixed Weight",
  lang707: "Weighing",
  lang708: "Tare Weight",
  lang709: "Other",
  lang710: "Place of Origin Name",
  lang711: "Fishing Date",
  lang712: "Select Year",
  lang713: "Select Month",
  lang714: "Select Package Weight",
  lang715: "Average Weight (g)",
  lang716: "Specification proportion and Size",

  lang717:
    "Please specify the proportion and size distribution of the specifications included in the supply. For example: 'Specification 100-150 accounts for 25% and is relatively large; Specification 200-3000 accounts for 75% and is of normal size.'",
  lang718: "Delivery Address",
  lang719:
    "Qualification Documents (Customs Declaration, Quarantine Certificate, etc.)",
  lang720: "Data Report",
  lang721:
    "Sellers can only register before the bidding starts; please reserve sufficient time for registration.",
  lang722: "Bidding Date",
  lang723: "Bidding Time",
  lang724: "At Any Time Point",
  lang725: "Bidding Duration (minutes)",
  lang726: "Please enter the bidding duration",
  lang727: "Decision Time (seconds)",
  lang728: "Currency",
  lang729: "CNY",
  lang730: "USD",
  lang731: "Confirm Price",
  lang732: "Confirmed",
  lang733: "Not Available",
  lang734: "Price (USD/ton)",
  lang735:
    "After the transaction is completed, the platform will charge you a service fee of 5 USD/ton.",
  lang736: "Performance Bond",

  lang737:
    "The performance bond is an important guarantee to ensure the smooth and orderly progress of transactions. When the transaction is completed and reaches the concluded status, or the seller takes the initiative to delist the product, the system will refund the full amount of the performance bond through the original payment method.",
  lang738: "Time-limited Free",
  lang739: "Insufficient balance, go to recharge",
  lang740: "Price Reduction Range",
  lang741: "Reserve Price",
  lang742: "Bidding Security Deposit (CNY)",
  lang743: "Estimated Time of Arrival at Port",
  lang744: "Port of Arrival",
  lang745: "Release Method",
  lang746: "Release Immediately",
  lang747: "Scheduled Transaction",
  lang748: "Transaction Start",
  lang749: "Select Date and Time",
  lang750: "Splitable?",
  lang751: "Purchase Method",
  lang752: "Split selling",
  lang753: "Minimum Transaction Volume",
  lang754: "Multiple of Tons",
  lang755: "Not Less Than",
  lang756: "Ton",
  lang757: "Delisting Method",
  lang758: "Less Than",
  lang759:
    "Automatically delist after the remaining quantity is less than [input] tons",
  lang760: "Manual Delisting",
  lang761: "Deposit Percentage (%)",
  lang762: "Warehouse Receipt",
  lang763: "Waiting for review after submission",
  lang764: "Please select a category",
  lang765: "Please select supply’s name",
  lang766: "Please enter a number, up to 4 decimal places allowed",
  lang767: "Please select a bidding date",
  lang768: "Please select a bidding time",
  lang769: "Please select an address",
  lang770: "Please select a release method",
  lang771: "Please select starting time of the transaction",
  lang772: "Please enter the minimum transaction multiple",
  lang773: "Please enter the minimum transaction volume",
  lang774: "Please select a delisting method",
  lang775: "Please enter the tonnage condition for automatic delisting",
  lang776: "Please select a payment mode",
  lang777: "Please enter the deposit percentage",
  lang778: "Please select a currency",
  lang779: "Please enter the registration fee",
  lang780: "Please enter a number, up to 2 decimal places",
  lang781: "Please enter the decision time",
  lang782: "Please enter the reserve price",
  lang783: "Please select whether to accept financial payment",
  lang784: "Please select whether the price is confirmed",
  lang785: "Please enter the estimated time of arrival at port",
  lang786: "Please enter the port of arrival",
  lang787: "Please select a cold storage",
  lang788: "Argentine Red Shrimp Zone",
  lang789: "January",
  lang790: "February",
  lang791: "March",
  lang792: "April",
  lang793: "May",
  lang794: "June",
  lang795: "July",
  lang796: "August",
  lang797: "September",
  lang798: "October",
  lang799: "November",
  lang800: "December",
  lang801: "Regular Listing",
  lang802: "Regular Bidding",
  lang803: "Dynamic Bidding",
  lang804: "Please select a zone",
  lang805: "Hook Fishing",
  lang806: "Net Fishing",
  lang807: "Light Fishing",
  lang808: "Mixed Goods",
  lang809: "Image Upload Error",
  lang810: "Argentine squid",
  lang811: "Common Squid",
  lang812: "Indian Ocean Squid",
  lang813: "Four Removals (with head-off)",
  lang814: "Five Removals (with head-off)",
  lang815: "Raw Squid Fins",
  lang816: "Raw Squid Slices",
  lang817:
    "The Weight Information (Small) Cannot Be Greater Than the Weight Information (Large)",
  lang818: "Please enter complete average weight information",
  lang819: "Fixed Weight, Package Weight,",
  lang820: "Weighing, Tare Weight,",
  lang821: "Please enter complete sales method information.",
  lang822: "Please enter complete package weight information",
  lang823: "Please upload supply photos",
  lang824: "Please upload warehouse receipt photos",
  lang825: "Service exception, please contact the administrator~",
  lang826: "Default",
  lang827: "Step 1: Select Account Type",
  lang828: "Account Type",
  lang829: "Enterprise",
  lang830: "Individual Industrial and Commercial Entity",
  lang831: "Step 2: Upload Identity Information",
  lang832: "Please upload ID card",

  lang833:
    "1. Photos must be clear and complete, with information such as text, numbers, patterns, etc. clearly identifiable, without blurring, double images or obstructions.",
  lang834:
    "2. Must be a clear color photo of the original document; black-and-white photos and photos of copies are invalid.",
  lang835: "Name",
  lang836: "Please enter a valid phone number",
  lang837: "Please check the legal representative's phone number",
  lang838: "Please upload the business license",
  lang839:
    "Please upload the portrait side of the legal representative's ID card",
  lang840:
    "Please upload the national emblem side of the legal representative's ID card",
  lang841: "Please upload the portrait side of the handler's ID card",
  lang842: "Please upload the national emblem side of the handler's ID card",
  lang843: "Please upload the portrait side of the ID card",
  lang844: "Please upload the national emblem side of the ID card",
  lang845: "Please read and check the agreement",
  lang846: "Please upload a photo of the bank card",
  lang847: "Account Association",
  lang848: "Main Account Information",
  lang849: "(Currently logged-in account)",
  lang850: "Entity Name",
  lang851: "Legal Representative",
  lang852: "Entity Account",
  lang853: "Sub-account List",
  lang854: "Add Account",
  lang855: "Role",
  lang856: "View",
  lang857: "Unbind Account",
  lang858: "Sub-account Role",
  lang859: "Finance Personnel",
  lang860: "Trader",
  lang861: "Account Administrator",
  lang862: "Bind Mobile Number",
  lang863: "Account Administrator Information",

  lang864:
    "The photo content must be true and valid, and must not be modified in any way. Only JPG, GIF, PNG, JPEG image formats are supported. The image size must not exceed 10M.",
  lang865: "Please upload both the front and back sides of the ID card",
  lang866: "Please complete the following information",
  lang867: "ID Card Number",
  lang868: "ID Card Expiry Date",
  lang869: "Administrator's Phone Number",
  lang870: "Please enter (not the currently logged-in account)",
  lang871: "Re-enter to confirm the filled content",
  lang872: "Current Account Phone Number",
  lang873: "SMS Verification Code",
  lang874: "Sub-account Addition Agreement",
  lang875: "Submit Sub-account Information",
  lang876: "Please select a role",
  lang877: "Resend",
  lang878: "Please upload the portrait side of the ID card",
  lang879: "Please upload the national emblem side of the ID card",
  lang880: "Please read and check the relevant agreement",
  lang881: "The two entered phone numbers do not match",
  lang882: "This operation will unbind this account. Continue?",
  lang883: "Unbind successfully",
  lang884: "Transaction Date",
  lang885: "Type",
  lang886: "Amount",
  lang887: "Serial Number",
  lang888: "Account Balance",
  lang889: "Current Entity",
  lang890: "Actual Account Balance (CNY)",
  lang891: "Amount in Transit (CNY)",
  lang892: "Frozen Amount (CNY)",
  lang893: "Account Recharge",
  lang894: "Withdraw Money",
  lang895: "Account Details",
  lang896: "Recharge Process",
  lang897: "Bound Cards",
  lang898: "Step 1: Confirm the Bound Bank Card",
  lang899: "Re-verify",
  lang900: "Pending Payment Verification",
  lang901: "One-click Rebind",
  lang902: "My Account",
  lang903:
    "Step 2: Use the above bank card to remit money to the following account",
  lang904: "Account Name",
  lang905: "Account Number",
  lang906: "Bank Name",
  lang907: "One-click Copy of Account Information",
  lang908: "Click to view detailed recharge tutorial",
  lang909: "Corporate Transfer",
  lang910: "Personal Transfer",
  lang911: "Agricultural Bank of China",
  lang912: "In the ABC App homepage, click the 'Transfer' icon",
  lang913: "After entering the transfer page, click 'Account Transfer'",
  lang914:
    "On the account transfer page, fill in the information, search for the recipient bank 'JIANGSU SU MERCHANTS BANK CO., LTD. ', and proceed to recharge.",
  lang915: "Industrial and Commercial Bank of China",
  lang916: "In the ICBC App homepage, click the 'Transfer & Remittance' icon",
  lang917: "Enter the transfer & remittance page, click 'Domestic Remittance'",

  lang918:
    "On the domestic remittance page, fill in the information and then the bank will be automatically identified. If 'JIANGSU SU MERCHANTS BANK CO., LTD. ' is not successfully identified, please search for 'JIANGSU SU MERCHANTS BANK CO., LTD. ', select it, and then proceed to recharge.",
  lang919: "Bank of China",
  lang920: "In the BOC App homepage, click the 'Transfer' icon",
  lang921: "Enter the transfer & remittance page, click 'Account Transfer'",

  lang922:
    "On the account transfer page, fill in the information and then the bank will be automatically identified. If 'Suzhou Commercial Bank' is not successfully identified, please search for 'JIANGSU SU MERCHANTS BANK CO., LTD. ', select it, and then proceed with recharge.",
  lang923: "China Construction Bank",
  lang924: "In the CCB APP homepage, click the 'transfer & remittance' icon",
  lang925: "Enter the transfer & remittance page，click 'Bank Account Transfer",

  lang926:
    "On the account transfer page, fill in the information and then the bank will be automatically identified. If 'JIANGSU SU MERCHANTS BANK CO., LTD. ' is not successfully identified, please search for 'JIANGSU SU MERCHANTS BANK CO., LTD.', select it, and then proceed with recharge.",
  lang927: "Confirm to unbind?",
  lang928: "Copied successfully!",
  lang929: "Copy failed!",
  lang930: "Receiving Bank Card",
  lang931: "Withdrawal Amount",
  lang932: "Currently Available Withdrawal Amount",
  lang933: "Withdraw All",

  lang934:
    "The Large Value Payment System of the People's Bank of China (PBOC) suspends external services from 17:15 to 20:30 on working days and during public holidays. If you need to withdraw a single amount exceeding 1 million yuan during this period, please split the withdrawal into multiple transactions.",
  lang935: "Please select the receiving bank card",
  lang936: "Please enter the withdrawal amount",
  lang937: "My Purchases",
  lang938: "My Sales",
  lang939: "Order Details",
  lang940: "Quick-Calculation Order No.",
  lang941: "This Order",
  lang942: "Order Creation Time",
  lang943: "Pre-loan Notice: Loan Annual Interest Rate: 4.2%",

  lang944:
    "*China Construction Bank does not charge any fees except interest and has not entrusted any company to collect fees from customers on its behalf.",
  lang945: "Actual Delivery Quantity",
  lang946: "Total Goods Value",
  lang947: "Down Payment",
  lang948: "Deposit",
  lang949: "First Payment",
  lang950: "First Receipt",
  lang951: "Pending Payment",
  lang952: "Waiting for buyer to pay",
  lang953: "Paid",
  lang954: "Received",
  lang955: "Total Payment",
  lang956: "Total Receipt",
  lang957: "Coupon",
  lang958: "Deal Closer",
  lang959: "Payment Record",
  lang960: "Receipt Record",
  lang961: "Fee Type",
  lang962: "Invoice Record",
  lang963: "Upload Invoice",
  lang964: "Invoice Name",
  lang965: "Pickup Application",
  lang966: "Pay Service Fee",
  lang967: "Pre-approval Signing",
  lang968: "Sign Contract",
  lang969: "Go to Pay",
  lang970: "Operation Log",
  lang971: "Image formats: PNG, JPG, JPEG, PDF.",
  lang972: "Image size: Not exceeding 3 MB.",
  lang973:
    "Image resolution: Greater than 15×15 pixels, less than 4096x4096 pixels.",
  lang974: "Confirm Upload",
  lang975: "Invoice",
  lang976: "Are you sure you want to delete this invoice?",
  lang977:
    "Only one upload is allowed. Please delete the existing one before re-uploading.",
  lang978: "Pending Delivery",
  lang979: "Pending Payment",
  lang980: "Completed",
  lang981: "View Details",
  lang982: "Repayment and Pickup",
  lang983: "My Published Transactions",
  lang984: "Pending Review",
  lang985: "Displaying",
  lang986: "Ended",
  lang987: "Rejected",
  lang988: "My Transactions (Buy)",
  lang989: "My Transactions (Sell)",
  lang990: "Service Upgrade",
  lang991: "To provide you with a better service experience,",
  lang992: "and to ensure our cooperation is smoother and more compliant,",
  lang993: "we invite you to upgrade your account.",
  lang994:
    "Please click [Supplemental Signing of the ‘Account Opening Agreement’]",
  lang995: "Please remind the account administrator",
  lang996: "Please note to check and receive the SMS",
  lang997: "and complete the signing according to the SMS instructions",
  lang998: "Thank you for your support and cooperation.",
  lang999: "Supplemental Signing of the ‘Account Opening Agreement’",
  lang1000: "Re-initiate Verification",
  info1: "Handler's Phone Number",
  info2: "Get Verification Code",
  info3: "Open an Account",
  info4:
    "After opening an account, you can complete transactions on the platform",
  info5: "Account opening failed, need to reopen an account",
  info6: "Payment Failed",
  info7: "Go to Verify",
  info8: "Payment Verification Failed",
  info9: "Processing",
  info10: "Review Failed",
  info11: "Pending Small Payment",
  info12: "Being Processed",
  info13: "Send Agreement",
  info14: "Legal representative needs to sign the 'Account Opening Agreement'",
  info15: "Legal representative needs to sign the 'Account Opening Agreement'",
  info16:
    "Waiting for legal representative to sign the 'Account Opening Agreement'",
  info17: "Verification code cannot be empty",
  info18: "Personal Homepage",
  info19: "Account Association",
  info20: "I Published",
  info21: "My Registered Bids",
  info22: "My Liked Articles",
  info23: "Log Out",
  info24: "Not Concluded",
  info25: "Repayment and Pickup",
  info26: "Available Quantity (Ton)",
  info27: "Category Item Specification",
  info28: "Inbound Quantity (Ton)",
  info29: "Remaining Quantity (Ton)",
  info30: "Applying Weight (Ton)",
  info31: "Cold Storage Name",
  info32: "Inbound Date",
  info33: "Storage Location",
  info34: "Material Number",
  info35: "Logistics Tracking Number",
  info36: "Logistics License Plate Number",
  info37: "Logistics Driver’s Name",
  info38: "Logistics Shipment Start Time",
  info39: "Logistics Arrival Time",
  info40: "Outbound Record",
  info41: "Pickup Tonnage",
  info42: "Pick All",
  info43:
    "After submitting the application, a platform specialist will contact you. Please wait.",
  info44: "Remaining Inventory",
  info45: "Outbound Order Number",
  info46: "Please enter the pickup tonnage",
  info47: "Please select the pickup date",
  info48: "Pickup Successful",
  info49: "Validity period of ID card",
  info50: "Occupation",
  info51: "Step 2: Upload basic information",
  info52: "Company Name",
  info53: "Business term",
  info54: "Registered address",
  info55: "Unified social credit code",
  info56: "Registered capital",
  info57: "Enterprise contact number",
  info58: "Please upload the legal representative's ID card",
  info59: "Legal person's name",
  info60: "Legal person ID number",
  info61:
    'The legal representative himself/herself needs to sign the "Account Opening Agreement". Please confirm that the mobile phone number is correct.',
  info62: "Legal person mobile phone number",
  info63: "Confirmation of the legal representative's mobile phone number",
  info64: "Please upload the ID card of the person in charge",
  info65: "Name of the person in charge",
  info66: "Id number of the person in charge",
  info67: "Validity period of ID card",
  info68: "Step 3: Bind your bank card",
  info69: "Send verification code",
  info70:
    'I have read and agreed to all the contents of the "Membership Ledger Service Agreement for Scene Payment Business of Jiangsu Sushang Bank" and accept the constraints of this agreement',
  info71: "Account opening successful",
  info72: "Completed",
  info73: "Squid",
  info74: "Cod",
  info75: "White Shrimp",
  info76: "Yuan",
  info77: "This operation will delete the offer. Do you want to continue?",
  info78:
    "After the transaction is completed, the platform will charge you a service fee of 50 RMB/ton.",
};



// WEBPACK FOOTER //
// ./src/lang/en.js